<template>
  <div class="kbs-visitor">
    <el-collapse v-model="activeName" accordion @change="handleCollapseChange">
      <template v-for="visitor in visitorStepList">
        <div :key="visitor.id">
          <el-collapse-item :name="visitor.id">
            <template slot="title">
              <div class="kbs-visitor-title">
                <span class="left">{{ visitor.agents[0].agentName }}</span>
                <span class="center">{{ visitor.startTime }}</span>
                <span class="right">
                  <i class="iconfont iconxiangqing"></i>
                </span>
              </div>
            </template>
          </el-collapse-item>
        </div>
      </template>
    </el-collapse>
    <el-dialog
      width="66%"
      center
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :modal="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      @close="handleClose"
    >
      <div class="chat-wrapper">
        <!-- 对话框 -->
        <div class="bottom">
          <!-- 滚动条 -->
          <div v-if="chatList.length <= 0" class="bottom-no-data">暂无数据</div>
          <div v-else v-for="item in chatList" :key="item.id" class="bottom-wraper">
            <!-- 客户 -->
            <div v-if="item.direction === 'up'" class="chat-client item clearfix">
              <span>
                <i>客户</i>
                {{ item.createTime }}
              </span>
              <div class="chatbox-left">
                <p v-html="translateMessage(item.type, item.msgContent)"></p>
              </div>
            </div>
            <!-- 坐席 -->
            <div v-if="item.direction === 'down'" class="chat-ai item clearfix">
              <span>
                {{ item.createTime }}
                <i>客服</i>
              </span>
              <div class="chatbox-right">
                <p v-html="translateMessage(item.type, item.msgContent)"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getVisitorStepList, getChatLog } from '@/api/crm/widgets'
export default {
  props: {
    visitId: {
      require: true,
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeName: '',
      visitorStepList: [],
      chatList: [],
      dialogTitle: '服务详情',
      dialogVisible: false,
      resourceDownloadPath: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_WB_SERVICE') + '/res/download'
    }
  },
  watch: {
    // 通过visitId的变化获取访客轨迹
    visitId(val) {
      this.getSessionLog()
    }
  },
  created() {
    if (this.visitId) {
      this.getSessionLog()
    }
  },
  methods: {
    // 获取服务详情
    getSessionLog() {
      const options = { userId: this.visitId }
      getVisitorStepList(options).then(res => {
        this.visitorStepList = res.data
      })
    },
    // 获取对话详情
    handleCollapseChange(activeName) {
      if (!activeName) return
      const index = this.visitorStepList.findIndex(
        item => item.id === activeName
      )
      this.dialogVisible = true
      const options = {
        // 2020年4月22日接口改动只需要传sessionId即可
        // agentId: this.visitorStepList[index].agents[0].agentId,
        sessionId: this.visitorStepList[index].sessionId
      }
      getChatLog(options).then(res => {
        this.chatList = res.data
      })
    },
    // 转义消息中的表情、图片、文件和换行符
    translateMessage(type, body) {
      if (type === 'image') {
        return '<img style="max-width:150px" src="' + this.resourceDownloadPath + body.url + '"/>'
      } else if (type === 'file') {
        return (
          '<div>' +
          (body.name.length > 15
            ? body.name.substring(0, 15) + '...'
            : body.name) +
          '</div>'
        )
      } else if (type === 'video') {
        return (
          '<div><video style="width:100%" controls="controls" src="' + this.resourceDownloadPath +
          body.url +
          '"></video></div>'
        )
      } else if (type === 'text') {
        body.content = body.content.replace('\n', '<br />')
        return body.content
      }
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.kbs-visitor-title {
  width: 100%;
  text-align: center;
  color: #303133;
  font-size: 14px;
  padding-top: 3px;
  .left {
    float: left;
    width: 25%;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .center {
    display: inline-block;
    width: 50%;
    text-align: center;
    font-size: 12px;
    color: #9f9f9f;
  }
  .right {
    float: right;
    width: 25%;
    text-align: right;
  }
}
.el-collapse {
  border: none;
}
.bottom {
  height: 82vh;
  width: 100%;
  overflow: auto;
  .bottom-no-data {
    text-align: center;
    color: #e3e3e3;
    line-height: 72vh;
  }
}
.bottom .chat-client,
.bottom .chat-ai {
  padding: 10px 0;
  i {
    font-style: normal;
    display: inline-block;
    margin-right: 10px;
  }
}
.bottom .chat-ai {
  i {
    margin-left: 10px;
  }
}
.bottom .chat-client span {
  box-sizing: border-box;
  width: 100%;
  height: 20px;
  font-size: 12px;
  display: block;
  // padding-left: 12px;
  text-align: left;
  color: #e3e3e3;
}
.bottom .chat-ai span {
  box-sizing: border-box;
  width: 100%;
  height: 20px;
  font-size: 12px;
  text-align: right;
  // padding-right: 12px;
  display: block;
  color: #e3e3e3;
}
.chatbox-right {
  position: relative;
  max-width: 70%;
  min-width: 100px;
  min-height: 34px;
  background-color: #6ec2fe;
  color: #fff;
  border-radius: 5px;
  float: right;
  margin-right: 12px;
  padding: 7px 20px;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 20px;
}
.chatbox-right p {
  position: relative;
  margin: 0 !important;
  line-height: 20px;
}
.chatbox-right p::after {
  content: '';
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-left: 6px solid #6ec2fe;
  border-right: 6px solid transparent;
  border-bottom: 6px solid transparent;
  right: -30px;
  top: 5px;
}
.chatbox-left {
  position: relative;
  max-width: 70%;
  min-width: 100px;
  min-height: 34px;
  background-color: #f0f0f0;
  color: #000;
  border-radius: 5px;
  float: left;
  margin-left: 12px;
  padding: 7px 20px;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 20px;
}
.chatbox-left p {
  position: relative;
  margin: 0 !important;
  line-height: 20px;
}
.chatbox-left p::after {
  content: '';
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-left: 6px solid transparent;
  border-right: 6px solid #f0f0f0;
  border-bottom: 6px solid transparent;
  left: -30px;
  top: 5px;
}
</style>
<style lang="scss">
.kbs-visitor {
  height: calc(100vh - 250px) !important;
  overflow: auto;
  .el-collapse-item__header {
    border-bottom: none;
  }
}
.kbs-visitor .el-collapse-item {
  margin-bottom: 2px !important;
}
.kbs-visitor .el-collapse-item__header.is-active .right {
  color: #6aa1fd;
}
.kbs-visitor .el-collapse-item__header {
  height: 40px !important;
  line-height: 40px !important;
  background-color: #fafafa;
  border-bottom: none !important;
  padding: 0 20px;
}
.kbs-visitor .el-collapse-item__header .el-collapse-item__arrow {
  display: none;
}
.kbs-visitor .el-collapse-item__content {
  display: none !important;
  padding-bottom: 0 !important;
}
</style>
